define((require) => {
    "use strict";

    var _                 = require("underscore"),
        EditorEvents      = require("shared/services/EditorEvents"),
        EventDispatcher   = require("shared/util/EventDispatcher"),
        ProjectAsset      = require("ui/editor/project/ProjectAsset"),
        LoggedInUserState = require("shared/ui/user/LoggedInUserState"),
        Preconditions     = require("shared/util/Preconditions");

    // TODO Candidate to be deleted and handle logic in Project class.

    return EventDispatcher.extend("Project Context", {

        /**
         * The project associated to the context, never null.
         *
         * @type {ProjectModel}
         */
        project: null,

        /**
         * Constructor
         */
        constructor: function(options) {
            Preconditions.checkArgument(options.project);

            _.extend(this, options);
        },

        /**
         * Attaches a model or collection of models into a project, by also adding them to the project collection.
         * FinalLy it re-fetches experiences because their projectId attribute may have changed.
         *
         * @param {ImprovedModel|ImprovedModel[]|Backbone.Collection} model - model or collection of models to be attached and added to the project.
         * @returns {Promise}
         */
        attach: function(model) {
            this._triggerEditorEvents(model, true);
            return this.project.attach(model);
        },

        /**
         * Detaches a model or collection of models into a project, by also removing them to the project collection.
         * FinalLy it re-fetches experiences because their projectId attribute may have changed.
         *
         * @param {ImprovedModel|ImprovedModel[]|Backbone.Collection} model - model or collection of models to be attached and added to the project.
         *
         * @returns {Promise}
         */
        detach: function(model) {
            this._triggerEditorEvents(model, false);
            return this.project.detach(model);
        },

        /**
         * Clears all assets from a project by type, i.e. <tt>ProjectAsset.Type.XXX</tt>.
         *
         * @param {String} type The asset type, as a <tt>ProjectAsset.Type.XXX</tt> constant value.
         */
        clear: function(type) {
            this.project.clear(type);
        },

        dispose: function() {
            this.project = null;
            this.stopListening();
        },


        /**
         * Tracks Mix Panel events for attach and detach actions within a context of a project.
         * @param modelsOrAssets Set of models or assets.
         * @param isAttaching Whether we ara attaching or detaching a model or asset.
         * @private
         */
        _triggerEditorEvents: function(modelsOrAssets, isAttaching) {
            // Normalize to array.
            modelsOrAssets = ProjectAsset.toArray(modelsOrAssets);

            _.each(modelsOrAssets, (modelOrAsset) => {
                var assetType = modelOrAsset.get("type");

                // This is needed as images and channels do not pass assets when being attached, but Backbone models.
                if (!assetType) {
                    var asAsset = ProjectAsset.asAsset(modelOrAsset);
                    if (asAsset) {
                        assetType = asAsset.get("resourceType");
                    } else {
                        return; // it will continue the next iteration as a valid asset could not be found.
                    }
                }

                this._trackEditorEvent(isAttaching, assetType, modelOrAsset);
            });
        },

        /**
         * Track editor event for the single asset being attached or detached.
         * @param {Boolean} isAttaching Whether we are attaching or detaching an asset to the project.
         * @param {String} assetType The type of asset.
         * @param {ProjectModel | ProjectAsset} modelOrAsset The project model or project asset to be attached / detached.
         * @private
         */
        _trackEditorEvent: function(isAttaching, assetType, modelOrAsset) {
            var eventName = null,
                eventProperties = {},
                triggerOrigin = isAttaching ? "AttachButton" : "DetachButton";

            switch (assetType) {
                case ProjectAsset.Type.EXPERIENCE:
                    eventName = isAttaching ? EditorEvents.constants.ATTACH_EXPERIENCE : EditorEvents.constants.DETACH_EXPERIENCE;
                    eventProperties = {
                        experienceId: modelOrAsset.get("id"),
                        experienceVersion: modelOrAsset.get("version"),
                        experiencePushedVersion: modelOrAsset.get("pushedVersion")
                    };

                    break;

                case ProjectAsset.Type.IMAGE:
                    eventName = isAttaching ? EditorEvents.constants.ATTACH_IMAGE : EditorEvents.constants.DETACH_IMAGE;
                    eventProperties = {
                        imageId: modelOrAsset.get("id"),
                        imageName: modelOrAsset.get("name")
                    };

                    break;

                case ProjectAsset.Type.CHANNEL:
                    eventName = isAttaching ? EditorEvents.constants.ATTACH_CHANNEL : EditorEvents.constants.DETACH_CHANNEL;

                    eventProperties = {
                        channelId: modelOrAsset.get("id"),
                        channelName: modelOrAsset.get("name"),
                        channelSelector: modelOrAsset.get("selector"),
                        channelUrl: modelOrAsset.get("url") || ""
                    };

                    var experience = modelOrAsset.get("experience");

                    if (experience) {
                        eventProperties.channelExperienceId = experience.get("id");
                        eventProperties.channelExperienceVersion = experience.get("version");
                        eventProperties.channelExperiencePushedVersion = experience.get("pushedVersion");
                    }

                    break;

                case ProjectAsset.Type.LOCALIZATIONGROUP:
                case ProjectAsset.Type.BREAKPOINTGROUP:
                    eventName = isAttaching ? EditorEvents.constants.ATTACH_GROUP : EditorEvents.constants.DETACH_GROUP;
                    eventProperties = {
                        groupId: modelOrAsset.get("id"),
                        groupVersion: modelOrAsset.get("version"),
                        groupPushedVersion: modelOrAsset.get("pushedVersion"),
                        groupType: assetType
                    };
                    break;
                default:
                    // TODO Candidate for refactoring during MOS-2934.
                    Preconditions.warn("DefaultSwitchWarn - Asset type '" + assetType + "' not recognized.");
                    break;
            }

            EditorEvents.trigger(eventName, _.extend(eventProperties, {
                triggerOrigin: triggerOrigin,
                projectId: this.project.get("id")
            }));
        }
    }, {
        mapContent: function() {
            var map = new Map();

            LoggedInUserState.get("projects").each((project) => {
                var publishableAssets = project.publishables(),
                    projectID = project.get("id");

                // Iterate through the project content and add them to the map
                publishableAssets.forEach((publishable) => {
                    map.set(publishable.get("resourceId"), projectID);
                });
            });

            return map;
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/project/ProjectContext.js